module.exports = __webpack_public_path__ + "img/bold-blue-checkbox-unchecked.33838765.svg";